import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import api from '../../config/configApi';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LineChart,
  Line,
  ResponsiveContainer,
} from "recharts";
// Definindo a interface do paciente
interface Paciente {
  id: number;
  nome: string;
  motivo: string;
  dataInicio: string;
  dataFim: string;
  CD_BENEFICIARIO?: string;
  nmPaciente?: string;
}

// Definindo a interface do mesData
interface MesData {
  mes: string;
  pacientes: Paciente[];
}

function groupMonthsInThrees(months: MesData[]): MesData[][] {
  const grouped: MesData[][] = [];
  for (let i = 0; i < months.length; i += 3) {
    grouped.push(months.slice(i, i + 3));
  }
  return grouped;
}

const inclusoesSadData = [
  {
    ano: 2021,
    meses: [
      { mes: "Janeiro", pacientes: [] },
      { mes: "Fevereiro", pacientes: [] },
      { mes: "Março", pacientes: [] },
      { mes: "Abril", pacientes: [] },
      { mes: "Maio", pacientes: [] },
      { mes: "Junho", pacientes: [] },
      {
        mes: "Julho",
        pacientes: [
          {
            id: 1,
            nome: "Jose Nestor Alcantara Gondim",
            motivo: "Para reabilitação/ pós internação",
            dataInicio: "2021-07-01",
            dataFim: "2021-07-10",
          },
          {
            id: 2,
            nome: "Igor Limeira do Nascimento",
            motivo: "Pós AVCH (reabilitação)",
            dataInicio: "2021-07-02",
            dataFim: "2021-07-12",
          },
          {
            id: 3,
            nome: "Cleber Gomes da Costa",
            motivo: "Para reabilitação/ pós internação",
            dataInicio: "2021-07-03",
            dataFim: "2021-07-15",
          },
        ],
      },
      { mes: "Agosto", pacientes: [] },
      { mes: "Setembro", pacientes: [] },
      { mes: "Outubro", pacientes: [] },
      {
        mes: "Novembro",
        pacientes: [
          {
            id: 4,
            nome: "Sebastião Plácido de Almeida",
            motivo: "Pós internação clínica",
            dataInicio: "2021-11-05",
            dataFim: "2021-11-20",
          },
        ],
      },
      { mes: "Dezembro", pacientes: [] },
    ],
  },
  {
    ano: 2022,
    meses: [
      {
        mes: "Janeiro",
        pacientes: [
          {
            id: 5,
            nome: "Gerci de Lima Souza",
            motivo: "Pós-internação",
            dataInicio: "2022-01-10",
            dataFim: "2022-01-20",
          },
          {
            id: 6,
            nome: "Jose Costa",
            motivo: "Pós-internação",
            dataInicio: "2022-01-15",
            dataFim: "2022-01-25",
          },
          {
            id: 7,
            nome: "Jucy de Oliveira Sousa",
            motivo: "Selenidade",
            dataInicio: "2022-01-12",
            dataFim: "2022-01-14",
          },
          {
            id: 8,
            nome: "Manoel Ribamar Vasconcelos",
            motivo: "Pós internação home",
            dataInicio: "2022-01-20",
            dataFim: "2022-01-30",
          },
        ],
      },
      { mes: "Fevereiro", pacientes: [] },
      {
        mes: "Março",
        pacientes: [
          {
            id: 9,
            nome: "Maria Beatriz de Andrade",
            motivo: "Selenidade",
            dataInicio: "2022-03-01",
            dataFim: "2022-03-05",
          },
          {
            id: 10,
            nome: "Marisio de Azevedo Lima",
            motivo: "Oncológico - quadro clínico",
            dataInicio: "2022-03-07",
            dataFim: "2022-03-20",
          },
        ],
      },
    ],
  },
  {
    ano: 2023,
    meses: [
      { mes: "Janeiro", pacientes: [] },
      {
        mes: "Fevereiro",
        pacientes: [
          {
            id: 11,
            nome: "Luana Costa",
            motivo: "Pós-cirurgia",
            dataInicio: "2023-02-01",
            dataFim: "2023-02-10",
          },
          {
            id: 12,
            nome: "Carlos Oliveira",
            motivo: "Pós-internação clínica",
            dataInicio: "2023-02-05",
            dataFim: "2023-02-15",
          },
        ],
      },
      {
        mes: "Março",
        pacientes: [
          {
            id: 13,
            nome: "Ricardo Alves",
            motivo: "Reabilitação",
            dataInicio: "2023-03-01",
            dataFim: "2023-03-05",
          },
          {
            id: 14,
            nome: "Ana Maria",
            motivo: "Tratamento clínico",
            dataInicio: "2023-03-10",
            dataFim: "2023-03-20",
          },
        ],
      },
      { mes: "Abril", pacientes: [] },
      { mes: "Maio", pacientes: [] },
      { mes: "Junho", pacientes: [] },
      { mes: "Julho", pacientes: [] },
      { mes: "Agosto", pacientes: [] },
      { mes: "Setembro", pacientes: [] },
      { mes: "Outubro", pacientes: [] },
      { mes: "Novembro", pacientes: [] },
      { mes: "Dezembro", pacientes: [] },
    ],
  },
  {
    ano: 2024,
    meses: [
      {
        mes: "Janeiro",
        pacientes: [
          {
            id: 15,
            nome: "Celina Pessoa de Melo",
            motivo: "Fratura de Fêmur",
            dataInicio: "2024-01-01",
            dataFim: "2024-01-10",
          },
          {
            id: 16,
            nome: "Luciano Coitinho do Nascimento",
            motivo: "Doença de Alzheimer",
            dataInicio: "2024-01-05",
            dataFim: "2024-01-15",
          },
          {
            id: 17,
            nome: "Mércia Maria Torres",
            motivo: "Carcinoma",
            dataInicio: "2024-01-12",
            dataFim: "2024-01-20",
          },
        ],
      },
      {
        mes: "Fevereiro",
        pacientes: [
          {
            id: 18,
            nome: "Antonia",
            motivo: "",
            dataInicio: "2024-02-01",
            dataFim: "2024-02-10",
          },
          {
            id: 19,
            nome: "Bernadete de Lourdes de Azevedo Lourenço",
            motivo: "Fratura Juncional",
            dataInicio: "2024-02-05",
            dataFim: "2024-02-15",
          },
          {
            id: 20,
            nome: "Aureanita Cavalcanti D´Araujo",
            motivo: "Artrose",
            dataInicio: "2024-02-10",
            dataFim: "2024-02-20",
          },
        ],
      },
      {
        mes: "Março",
        pacientes: [
          {
            id: 21,
            nome: "Ailton Parente de Alencar",
            motivo: "Doença de Alzheimer",
            dataInicio: "2024-03-01",
            dataFim: "2024-03-10",
          },
        ],
      },
      {
        mes: "Abril",
        pacientes: [
          {
            id: 22,
            nome: "Elijanete Gomes de Lima",
            motivo: "Doença de Alzheimer",
            dataInicio: "2024-04-01",
            dataFim: "2024-04-10",
          },
        ],
      },
      {
        mes: "Maio",
        pacientes: [
          {
            id: 23,
            nome: "Francisca Queiroga Câmara",
            motivo: "Demência Senil",
            dataInicio: "2024-05-01",
            dataFim: "2024-05-10",
          },
        ],
      },
      {
        mes: "Junho",
        pacientes: [
          {
            id: 24,
            nome: "Aluisio Targino",
            motivo: "NEO",
            dataInicio: "2024-06-01",
            dataFim: "2024-06-10",
          },
          {
            id: 25,
            nome: "Lucila Ferreira dos Santos",
            motivo: "Demência Senil / Síndrome da Mobilidade",
            dataInicio: "2024-06-05",
            dataFim: "2024-06-15",
          },
        ],
      },
      {
        mes: "Julho",
        pacientes: [
          {
            id: 26,
            nome: "Maria do Rosário Athayde Nóbrega",
            motivo: "Obesidade + HAS + Dislipidemia + Espondiloartrose",
            dataInicio: "2024-07-01",
            dataFim: "2024-07-10",
          },
          {
            id: 27,
            nome: "Maria Rosinete do Nascimento Cavalcanti",
            motivo: "MTT óssea e SNC, Síndrome da Imobilidade",
            dataInicio: "2024-07-05",
            dataFim: "2024-07-15",
          },
        ],
      },
      {
        mes: "Agosto",
        pacientes: [
          {
            id: 28,
            nome: "Marivaldo Soares",
            motivo: "NEO",
            dataInicio: "2024-08-01",
            dataFim: "2024-08-10",
          },
        ],
      },
      { mes: "Setembro", pacientes: [] },
      {
        mes: "Outubro",
        pacientes: [
          {
            id: 30,
            nome: "Mª Luzinete A. de Oliveira",
            motivo: "Doença de Alzheimer",
            dataInicio: "2024-10-01",
            dataFim: "2024-10-10",
          },
          {
            id: 31,
            nome: "Luzinete Gomes da Rocha",
            motivo: "NEO de Pâncreas MTT",
            dataInicio: "2024-10-05",
            dataFim: "2024-10-15",
          },
        ],
      },
      { mes: "Novembro", pacientes: [] },
      { mes: "Dezembro", pacientes: [] },
    ],
  },
];

export const InclusoesSad = () => {
  const navigate = useNavigate();
  const [selectedAno, setSelectedAno] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal visibility
  const [beneficiarios, setBeneficiarios] = useState<Paciente[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const [novoPaciente, setNovoPaciente] = useState({
    nome: "",
    motivo: "",
    dataInicio: "", // Adicionado campo de data de início
    dataFim: "", // Adicionado campo de data de fim
  });

useEffect(() => {
  const fetchBeneficiarios = async () => {
    try {
      const token = localStorage.getItem("Frontend"); // Obtém o token armazenado

      if (!token) {
        throw new Error("Token de autenticação não encontrado");
      }

      const response = await api.get("/sisclinic/pacientes", {
        headers: {
          Authorization: `Bearer ${token}`, // Adiciona o token ao cabeçalho da requisição
        },
      });

      setBeneficiarios(response.data);
    } catch (error) {
      console.error("Erro ao buscar beneficiários:", error);
    } finally {
      setLoading(false); // Garante que o estado de loading seja atualizado mesmo em caso de erro
    }
  };

  fetchBeneficiarios();
}, []);

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const handleAnoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedAno(parseInt(e.target.value));
  };

  const handleAdicionarPaciente = (e: React.FormEvent) => {
    e.preventDefault();
    const { nome, motivo, dataInicio, dataFim } = novoPaciente;
    const data = new Date();
    const anoAtual = data.getFullYear();
    const mesAtual = data.toLocaleString("pt-BR", { month: "long" });

    // Verifica se o ano atual já existe
    let anoAtualData = inclusoesSadData.find((d) => d.ano === anoAtual);

    // Adiciona o ano atual dinamicamente, se necessário
    if (!anoAtualData) {
      anoAtualData = {
        ano: anoAtual,
        meses: [
          { mes: "Janeiro", pacientes: [] },
          { mes: "Fevereiro", pacientes: [] },
          { mes: "Março", pacientes: [] },
          { mes: "Abril", pacientes: [] },
          { mes: "Maio", pacientes: [] },
          { mes: "Junho", pacientes: [] },
          { mes: "Julho", pacientes: [] },
          { mes: "Agosto", pacientes: [] },
          { mes: "Setembro", pacientes: [] },
          { mes: "Outubro", pacientes: [] },
          { mes: "Novembro", pacientes: [] },
          { mes: "Dezembro", pacientes: [] },
        ],
      };
      inclusoesSadData.push(anoAtualData);
    }

    // Localiza o mês dentro do ano
    const mesData = anoAtualData.meses.find(
      (m) => m.mes.toLowerCase() === mesAtual.toLowerCase()
    );

    if (mesData) {
      mesData.pacientes.push({
        nome,
        motivo,
        dataInicio,
        dataFim,
        id: 0,
      });
      alert("Paciente adicionado com sucesso!");
      setIsModalOpen(false); // Close modal after adding patient
      setNovoPaciente({ nome: "", motivo: "", dataInicio: "", dataFim: "" });
    } else {
      alert("Erro ao localizar o mês atual.");
    }
  };

  // Dados filtrados por ano selecionado
  const filteredData = inclusoesSadData.filter((anoData) =>
    selectedAno ? anoData.ano === selectedAno : true
  );

  // Transformando os dados para gráficos
  const getChartData = (anoData: (typeof inclusoesSadData)[0]) =>
    anoData.meses.map((mesData) => ({
      mes: mesData.mes,
      pacientes: mesData.pacientes.length,
    }));

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <motion.h1
        className="text-4xl font-extrabold text-gray-800 text-center mb-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        Inclusões SAD
      </motion.h1>

      <div className="flex justify-between items-center mb-6">
        <select
          className="p-2 bg-white border border-gray-300 rounded"
          onChange={handleAnoChange}
        >
          <option value="">Selecione o Ano</option>
          {inclusoesSadData
            .sort((a, b) => b.ano - a.ano) // Ordena de forma decrescente pelo ano
            .map((data) => (
              <option key={data.ano} value={data.ano}>
                {data.ano}
              </option>
            ))}
        </select>
        <button
          className="p-2 px-6 bg-red-600 text-white rounded-lg hover:bg-red-700 transition ease-in-out"
          onClick={() => navigate(-1)}
        >
          Voltar
        </button>
      </div>

      {/* Button to open modal */}
      <div className="bg-white p-6 shadow-md rounded-lg mt-8 mb-5">
        <h3 className="text-xl font-semibold text-gray-800 mb-6">
          Adicionar Paciente
        </h3>
        <button
          onClick={() => setIsModalOpen(true)} // Open modal when clicked
          className="p-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Adicionar Paciente
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          {" "}
          {/* Apliquei o z-50 aqui */}
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h3 className="text-2xl font-semibold mb-4">
              Adicionar Novo Paciente
            </h3>
            <form onSubmit={handleAdicionarPaciente}>
              <label htmlFor=""> Nome</label>
              <select
                value={novoPaciente.nome}
                onChange={(e) => {
                  setNovoPaciente({ ...novoPaciente, nome: e.target.value });
                }}
                className="p-2 border border-balck-300 rounded w-full mb-4 text-black-800"
              >
                <option value="">Selecione</option>
                {loading ? (
                  <option value="">Carregando...</option>
                ) : beneficiarios.length === 0 ? (
                  <option value="">Nenhum beneficiário disponível</option>
                ) : (
                  beneficiarios.map((beneficiario) => (
                    <option
                      key={beneficiario.CD_BENEFICIARIO}
                      value={beneficiario.nmPaciente}
                    >
                      {beneficiario.nmPaciente}
                    </option>
                  ))
                )}
              </select>
              <label htmlFor=""> Motivo</label>
              <input
                type="text"
                name="motivo"
                placeholder="Motivo da Inclusão"
                className="p-2 border border-gray-300 rounded w-full mb-4"
                value={novoPaciente.motivo}
                onChange={(e) =>
                  setNovoPaciente({ ...novoPaciente, motivo: e.target.value })
                }
                required
              />
              <label htmlFor=""> Data Início</label>
              <input
                type="date"
                name="dataInicio"
                className="p-2 border border-gray-300 rounded w-full mb-4"
                value={novoPaciente.dataInicio}
                onChange={(e) =>
                  setNovoPaciente({
                    ...novoPaciente,
                    dataInicio: e.target.value,
                  })
                }
                required
              />
              <label htmlFor=""> Data Fim</label>
              <input
                type="date"
                name="dataFim"
                className="p-2 border border-gray-300 rounded w-full mb-4"
                value={novoPaciente.dataFim}
                onChange={(e) =>
                  setNovoPaciente({
                    ...novoPaciente,
                    dataFim: e.target.value,
                  })
                }
                required
              />
              <div className="flex justify-between">
                <button
                  type="submit"
                  className="p-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Adicionar
                </button>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)} // Close modal
                  className="p-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {filteredData
        .sort((a, b) => b.ano - a.ano)
        .map((anoData) => (
          <div key={anoData.ano} className="mb-12">
            {/* Lista de Pacientes */}
            <div className="mt-8">
              {groupMonthsInThrees(anoData.meses).map((group, groupIndex) => (
                <div key={groupIndex} className="mb-8">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {group.map((mesData, mesIndex) => {
                      return (
                        <motion.div
                          key={mesData.mes}
                          className="bg-white p-6 shadow-lg rounded-xl transition-all transform hover:scale-105 hover:shadow-xl"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ duration: 0.5 }}
                        >
                          <h3 className="text-2xl font-semibold text-gray-800 mb-4">
                            {mesData.mes}
                          </h3>

                          {/* Se não houver pacientes, exibe uma mensagem */}
                          {mesData.pacientes.length === 0 ? (
                            <p className="text-gray-500 text-center">
                              Não tem pacientes cadastrados nesse mês.
                            </p>
                          ) : (
                            <ul className="list-disc ml-6 text-gray-700">
                              {mesData.pacientes.map(
                                (paciente: Paciente, index: number) => (
                                  <motion.li
                                    key={index}
                                    className="mb-2 text-sm"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.5 }}
                                  >
                                    <strong className="text-gray-900">
                                      {paciente.nome}
                                    </strong>{" "}
                                    - {paciente.motivo} -{" "}
                                    <span className="text-gray-500">
                                      {formatDate(paciente.dataInicio)} até{" "}
                                      {formatDate(paciente.dataFim)}
                                    </span>
                                  </motion.li>
                                )
                              )}
                            </ul>
                          )}
                        </motion.div>
                      );
                    })}
                  </div>
                </div>
              ))}
              <motion.h2
                className="text-3xl font-semibold text-gray-800 text-center"
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                {anoData.ano}
              </motion.h2>

              {/* Gráficos */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-6">
                <div className="bg-white shadow-md p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-700 mb-4">
                    Pacientes por Mês (Bar Chart)
                  </h3>
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={getChartData(anoData)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="mes" />
                      <YAxis />
                      <Tooltip />
                      <Bar dataKey="pacientes" fill="#8884d8" />
                    </BarChart>
                  </ResponsiveContainer>
                </div>

                <div className="bg-white shadow-md p-6 rounded-lg">
                  <h3 className="text-xl font-semibold text-gray-700 mb-4">
                    Evolução dos Pacientes (Line Chart)
                  </h3>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={getChartData(anoData)}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="mes" />
                      <YAxis />
                      <Tooltip />
                      <Line
                        type="monotone"
                        dataKey="pacientes"
                        stroke="#82ca9d"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};
